module.exports = __webpack_public_path__ + "media/creativeMedia/panel03Landscape-0128fbfb.png";